import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import it from './it.json';
import en from './en.json';

const STORAGE_KEY = 'niveo.lang';

function detectInitialLang(): 'it' | 'en' {
  if (typeof window === 'undefined') return 'it';
  const stored = window.localStorage?.getItem(STORAGE_KEY);
  if (stored === 'it' || stored === 'en') return stored;
  const nav = window.navigator?.language?.toLowerCase() ?? 'it';
  return nav.startsWith('en') ? 'en' : 'it';
}

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
    },
    lng: detectInitialLang(),
    fallbackLng: 'it',
    supportedLngs: ['it', 'en'],
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export function setLanguage(lng: 'it' | 'en'): void {
  void i18n.changeLanguage(lng);
  if (typeof window !== 'undefined') {
    window.localStorage?.setItem(STORAGE_KEY, lng);
  }
}

export default i18n;
